module.exports = __webpack_public_path__ + "static/media/tianyuan-2@2x.f83b1dc1.png";